import * as schemaRecurringTasks from "~/schemas/schema.recurring_tasks.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchRecurringTasks = (projectId) => {
  return {
    types: [
      actionTypes.FETCH_RECURRING_TASKS_LOADING,
      actionTypes.FETCH_RECURRING_TASKS_SUCCESS,
      actionTypes.FETCH_RECURRING_TASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/recurring-tasks`,
      }),
    payload: {
      projectId,
      schema: {
        recurring_tasks: schemaRecurringTasks.arrayOfRecurringTasks,
      },
    },
  };
};

export const moveToTrash = (taskId) => {
  return {
    types: [
      actionTypes.MOVE_RECURRING_TASK_TO_TRASH_LOADING,
      actionTypes.MOVE_RECURRING_TASK_TO_TRASH_SUCCESS,
      actionTypes.MOVE_RECURRING_TASK_TO_TRASH_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/move-to-trash/recurring-task/${taskId}`,
        method: `put`,
      }),
    payload: {
      taskId,
    },
  };
};

export const editRecurringTask = (projectId, taskId, attributes) => {
  return {
    types: [
      actionTypes.EDIT_RECURRING_TASK_LOADING,
      actionTypes.EDIT_RECURRING_TASK_SUCCESS,
      actionTypes.EDIT_RECURRING_TASK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/recurring-tasks/${taskId}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      taskId,
      attributes,
      schema: {
        single: schemaRecurringTasks.recurringTask,
      },
    },
  };
};

export const addRecurringTask = (projectId, attributes) => {
  return {
    types: [
      actionTypes.ADD_RECURRING_TASK_LOADING,
      actionTypes.ADD_RECURRING_TASK_SUCCESS,
      actionTypes.ADD_RECURRING_TASK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/recurring-tasks`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemaRecurringTasks.recurringTask,
      },
    },
  };
};

export const loadRecurringTask = (projectId, recurringTaskId) => {
  const url = `${Angie.api_url}/projects/${projectId}/recurring-tasks/${recurringTaskId}`;
  return {
    types: [
      actionTypes.FETCH_RECURRING_TASK_LOADING,
      actionTypes.FETCH_RECURRING_TASK_SUCCESS,
      actionTypes.FETCH_RECURRING_TASK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url,
      }),
    payload: {
      recurringTaskId,
      schema: {
        single: schemaRecurringTasks.recurringTask,
        subscribers: [],
      },
    },
  };
};

export const recurringTaskFromEventStream = (data = {}, type) => {
  if (data) {
    if (data.is_complete_data) {
      const { is_complete_data, ...rest } = data;
      return {
        type,
        response: rest,
        schema: schemaRecurringTasks.recurringTask,
      };
    }
  }

  return loadRecurringTask(data.project_id, data.id);
};

export const addRecurringTaskFromEventStream = (data) => {
  return recurringTaskFromEventStream(data, actionTypes.ADD_RECURRING_TASK_FROM_EVENT_STREAM);
};

export const recurringTaskMovedToTrashFromEventStream = (data) => {
  return recurringTaskFromEventStream(data, actionTypes.RECURRING_TASK_MOVED_TO_TRASH_FROM_EVENT_STREAM);
};

export const updateRecurringTaskFromEventStream = (data) => {
  return recurringTaskFromEventStream(data, actionTypes.UPDATE_RECURRING_TASK_FROM_EVENT_STREAM);
};

export const recurringTaskRestoredFromTrashFromEventStream = (data) => {
  return recurringTaskFromEventStream(data, actionTypes.RECURRING_TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM);
};
